"use client";

import { useEffect, useRef } from "react";

export function IntentionThread() {
  const ref = useRef<SVGSVGElement>(null);

  useEffect(() => {
    const root = ref.current;
    if (!root) return;
    let raf = 0;
    const update = (event?: PointerEvent) => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const max = document.documentElement.scrollHeight - innerHeight;
        root.style.setProperty("--thread-progress", String(max > 0 ? scrollY / max : 0));
        if (event?.pointerType === "mouse") {
          root.style.setProperty("--thread-x", `${(event.clientX / innerWidth - 0.5) * 10}px`);
        }
      });
    };
    const onScroll = () => update();
    const onPointerMove = (event: PointerEvent) => update(event);
    update();
    addEventListener("scroll", onScroll, { passive: true });
    addEventListener("pointermove", onPointerMove, { passive: true });
    return () => {
      cancelAnimationFrame(raf);
      removeEventListener("scroll", onScroll);
      removeEventListener("pointermove", onPointerMove);
    };
  }, []);

  return (
    <svg ref={ref} className="intention-thread" viewBox="0 0 100 1000" preserveAspectRatio="none" aria-hidden="true">
      <path className="thread-ghost" d="M8 0 C6 90 86 85 46 180 S12 310 55 390 S88 520 48 610 S15 760 51 850 S91 930 50 1000" />
      <path className="thread-live" pathLength="1" d="M8 0 C6 90 86 85 46 180 S12 310 55 390 S88 520 48 610 S15 760 51 850 S91 930 50 1000" />
    </svg>
  );
}
